import React, { FunctionComponent, useState, useCallback } from 'react';
import errorHandler from '../../../../../common/service/errorHandler';
import { IButtonClickAction } from '../../../presentational/actionButtons/ActionButtons';
import Submit from '../../../presentational/actionButtons/customiseSubmit/Submit';
import IActionButtonProps from '../IActionButtonProps';
import { useBasketInitV3 } from '../../../../hooks/useBasketInitV3';
import basketApi from '../../../../api/basketApi';
import { JourneyType } from '../../../../../__generated__/globalTypes';
import { AxiosResponse } from 'axios';
import IDeal from '../../../../../common/model/IDeal';
import urlMinify from '../../../../../common/utils/urlMinify';
import digitalApi from '../../../../../common/api/digitalApi';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import { StockVersionTypes } from '../../../../../gqlCommon/enum/StockVersionTypes';
import { useRequestUrl } from '../../../../hooks/useRequestUrl';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';
import SubmitWithStockPing from './SubmitWithStockPing';

const ReserveOnlineButtonContainer: FunctionComponent<IActionButtonProps> = ({ config }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const {
    platformConfig: { stockVersion, isCheckout3Enabled, gqlApi, hourDisableOrderNowFromTo },
  } = usePlatformConfig();
  const { selectedCar } = useCustomizeCarContext();
  const { getRequestQuoteUrl } = useRequestUrl();
  const { getBasketInitV3Data } = useBasketInitV3(JourneyType.reserve_online);

  const basketInitV3Data = getBasketInitV3Data();
  const buttonIsDisabled = !basketInitV3Data.vehicleId || isSubmitting || config.disabled;

  const onClick: IButtonClickAction = useCallback(async () => {
    setIsSubmitting(true);

    if (config.isCheckoutLiteEnabled && config.reserveOnlineUrl && basketInitV3Data) {
      if (gqlApi && isCheckout3Enabled) {
        const { url } = await getRequestQuoteUrl(config, JourneyType.reserve_online);
        setIsSubmitting(false);
        window.location.href = url;
        return;
      }

      const minifiedConfigurationUrl = await urlMinify.shorten(basketInitV3Data.configurationSourceUrl);
      const updatedBasketInitV3Data = {
        ...basketInitV3Data,
        configurationSourceUrl: minifiedConfigurationUrl,
      };

      try {
        const response: AxiosResponse<IDeal> = await basketApi.preInitBasketComplex(updatedBasketInitV3Data);
        if (response) {
          return digitalApi
            .reserveOnline()
            .then(() => {
              (window as any).location = config.reserveOnlineUrl;
            })
            .catch(error => {
              setIsSubmitting(false);
              errorHandler.handleError(error);
            });
        }
      } catch (error) {
        errorHandler.handleError(error);
      }
    }

    return new Promise((_resolve, reject) => {
      errorHandler.handleError(config);
      reject(new Error('Redirection should have happened'));
    });
  }, [getBasketInitV3Data]);

  if (stockVersion !== StockVersionTypes.NONE && !selectedCar?.stockInfo) {
    return null;
  }

  return hourDisableOrderNowFromTo ? (
    <SubmitWithStockPing onClick={onClick} disabled={buttonIsDisabled} />
  ) : (
    <Submit onClick={onClick} disabled={buttonIsDisabled} />
  );
};

export default ReserveOnlineButtonContainer;
